export default __webpack_public_path__ + "static/media/slide25.6a957987.jpg";